import React, { useState, useRef } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { useAuth } from '../core/AuthContext';
import { hasManageAccessControlPermission, hasManageUsersPermission } from '../core/utils/permissionUtils';
import '../styles/admin-selector.css';

const AdminSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();
  const isMountedRef = useRef(true);

  React.useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (isMountedRef.current && !e.target.closest('.admin-selector-container')) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const canManageAccessControl = hasManageAccessControlPermission(user);
  const canManageUsers = hasManageUsersPermission(user);

  const adminOptions = [
    {
      to: '/role-management',
      icon: 'f7:person-circle-fill',
      label: 'Role Management',
      visible: canManageAccessControl,
    },
    {
      to: '/permission-management',
      icon: 'f7:lock-circle-fill',
      label: 'Permission Management',
      visible: canManageAccessControl,
    },
    {
      to: '/users-bulk-edit',
      icon: 'mdi:table-edit',
      label: 'Member Tracking',
      visible: canManageUsers,
    },
  ].filter((option) => option.visible);

  const toggleDropdown = () => {
    if (isMountedRef.current) {
      setIsOpen(!isOpen);
    }
  };

  const handleLinkClick = () => {
    console.log("Admin option clicked: ", isMountedRef.current);
    if (isMountedRef.current) {
      setIsOpen(false);
    }
  };

  if (adminOptions.length === 0) {
    return null;
  }

  return (
    <div className="admin-selector-container">
      <button
        className="header-buttons admin-button"
        onClick={toggleDropdown}
        title="Admin Controls"
      >
        <Icon
          icon="material-symbols:admin-panel-settings"
          className="header-button-icon"
        />
        <p>Admin</p>
        <Icon
          icon={isOpen ? "material-symbols:expand-less" : "material-symbols:expand-more"}
          className="dropdown-arrow"
        />
      </button>

      {isOpen && (
        <div className="admin-dropdown">
          {adminOptions.map(({ to, icon, label }) => (
            <Link
              key={to}
              to={to}
              className="admin-option"
              onClick={handleLinkClick}
            >
              <Icon icon={icon} className="option-icon" />
              <span className="option-label">{label}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminSelector;
